import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  fullheightTablist: {
    height: 'calc(100vh - 90px)',
    minHeight: 990,
    background: theme.palette.common.white,
    display: 'flex',
    position: 'relative',
    '& .MuiTabs-root': {
      overflow: 'visible !important',
    },
    '& .MuiTabs-fixed': {
      overflow: 'visible !important',
    },
    '& .MuiTabs-flexContainer': {
      flexDirection: 'column',
      width: 480,
      overflow: 'hidden',
      paddingBottom: 6,
      [theme.breakpoints.up(1200)]: {
        width: 565,
      },
      [theme.breakpoints.up(1400)]: {
        width: 525,
      },
    },
    '& .MuiTab-root': {
      overflow: 'visible',
      width: '100%',
      maxWidth: '80%',
      padding: 0,
      opacity: '1 !important',
      justifyContent: 'flex-start',
      borderBottom: '1px solid #D8D8D8;',
      marginLeft: 2,
      '&.Mui-selected': {
        '& .MuiTab-wrapper': {
          color: theme.palette.secondary.light,
        },
        '& .fullheight-tablist-list-icon': {
          background: theme.palette.gold.main,
        },
        '&:after': {
          height: 2,
          background: theme.palette.secondary.light,
          width: '120%',
        },
        '& .is-selected-arrow-container': {
          transform: 'translateX(0) !important',
          opacity: 1,
        },
      },
    },
    '& .MuiTab-wrapper': {
      ...theme.typography.h6,
      color: '#6A6A6A',
      background: 'transparent',
      boxShadow: 'none',
      padding: '26px 0',
      margin: '0',
      display: 'flex',
      textTransform: 'none',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      textAlign: 'left',
      width: 300,
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '& button:nth-child(1)': {
      marginTop: 2,
    },
    '& button.Mui-selected, & button:focus': {
      outlineColor: theme.palette.secondary.light,
    },
  },
  maxWidthContainer: {
    width: '100%',
    maxWidth: 1440,
    height: '100%',
    margin: '0 auto',
    backgroundColor: theme.palette.blue.light100,
    paddingRight: '45%',
  },
  introContainer: {
    height: '100%',
    position: 'relative',
    marginBottom: 60,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.blue.light100,
    padding: '102px 72px 32px 32px',
    [theme.breakpoints.up(2200)]: {
      width: '500px',
    },
  },
  heading: {
    ...theme.typography.h2,
    color: theme.palette.secondary.light,
    marginBottom: 20,
    marginTop: 0,
  },
  supportiveCopy: {
    maxWidth: 732,
    marginBottom: 0,
    paddingRight: 105,
    [theme.breakpoints.up(1100)]: {
      paddingRight: 180,
    },
    [theme.breakpoints.up(1340)]: {
      paddingRight: 220,
    },
    [theme.breakpoints.up(1600)]: {
      paddingRight: 100,
    },
  },
  ctaContainer: {
    marginBottom: 40,
    marginTop: 40,
  },
  splitContainer: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.blue.light100,
    justifyContent: 'flex-end',
    alignItems: 'stretch',
    zIndex: 0,
  },
  imagerySection: {
    flexBasis: '55%',
    position: 'relative',
    background: '#00234B',
  },
  imagerySectionImg: {
    top: 0,
    left: 0,
    position: 'absolute',
    objectFit: 'cover',
    width: '100%',
    height: '100%',
  },
  titleIcon: {
    borderRadius: '50%',
    width: 36,
    height: 36,
    flexBasis: 36,
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 16,
    background: '#D8D8D8',
  },
  tabContainer: {
    position: 'relative',
  },
  starPointlistContainer: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    marginTop: 25,
    textAlign: 'left',
  },
  starPointlistItem: {
    ...theme.typography.h6,
    color: theme.palette.secondary.light,
    fontSize: '0.75rem',
    borderBottom: `0.5pt solid ${theme.palette.secondary.dark}`,
    padding: '15px 0',
    display: 'flex',
    alignItems: 'center',
  },
  isSelectedArrowContainer: {
    position: 'absolute',
    bottom: -13.5,
    left: -45,
    zIndex: 3,
    transition: 'all .25s ease',
    transform: 'translateX(-50px)',
    opacity: 0,
    [theme.breakpoints.up(1200)]: {
      left: -80,
    },
  },
}))

export default useStyles
